import React, { useEffect, useState, useRef } from 'react';
interface ParallaxSectionProps {
  children: React.ReactNode;
  speed?: number;
  className?: string;
}
export function ParallaxSection({
  children,
  speed = 0.5,
  className = ''
}: ParallaxSectionProps) {
  const [offsetY, setOffsetY] = useState(0);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        const scrolled = window.scrollY;
        const elementTop = rect.top + scrolled;
        const offset = (scrolled - elementTop) * speed;
        setOffsetY(offset);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [speed]);
  return <div ref={sectionRef} className={`relative overflow-hidden ${className}`} data-id="element-160">
      <div style={{
      transform: `translateY(${offsetY}px)`
    }} data-id="element-161">
        {children}
      </div>
    </div>;
}